import React from "react";
import PropTypes from "prop-types";
import { SocialMediaLinkInput, SingleCheckboxInput } from "components/Form";
import { Picture, Button, Modal } from "components/UI";
import { Spinner } from "components/UI/Loading";
import { iconPromo, imgTableBenefits } from "assets";
import Selectors from "selectors";
import Actions from "actions";
import { Field } from "formik";
import Pricing from "../Activate/Pricing";
import { isEmpty, isNull } from "lodash";
import useSubscriptionPlan from "hooks/useSubscriptionPlan";
import PricingCycle from "./PricingCycle";
import { useSelector } from "react-redux";

const SubscriptionPlan = ({
  billingCycle,
  selectedTier,
  isLoadingTiers,
  referralCode,
  errorPromo
}) => {
  if (isLoadingTiers) return <Spinner />;

  const isLoadingPromoCode = useSelector(
    Selectors.createLoadingSelector([Actions.VALIDATE_PROMO_CODE_REQUEST])
  );

  const { monthlyPrice, yearlyPrice } = useSubscriptionPlan(billingCycle);

  return (
    <div className="flex flex-col lg:px-16 items-center">
      <h5 className="text-2lg text-center text-rock">
        {`Apply to be a ${selectedTier?.name || ''} Member!`}
      </h5>
      <div className="flex flex-col sm:flex-row w-full items-center justify-around">
        {billingCycle === "month" ? (
          <PricingCycle amount={monthlyPrice} />
        ) : (
          <PricingCycle isAnnual amount={yearlyPrice} />
        )}
      </div>
      {/* {liteOnly && (
        <div className="text-rock mt-6 text-center">
          {`What are the `}
          <Modal content={<Picture src={imgTableBenefits} />}>
            <span className="text-easter cursor-pointer">
              perks &amp; benefits?
            </span>
          </Modal>
        </div>
      )} */}
      <div className="w-11/12 mt-4">
        <SocialMediaLinkInput
          className="w-full"
          name="promoCode"
          img={iconPromo.default}
          placeholder="Enter promo code…"
          isLoading={isLoadingPromoCode}
        />
      </div>
      {errorPromo && (
        <div className="mb-4 text-red-500">
          <p>{errorPromo}</p>
        </div>
      )}
      {referralCode && (
        <div className="mb-4 p-3 border-dotted border-easter border-2 bg-lily">
          <p>Referral code applied {referralCode}</p>
        </div>
      )}
      <Field
        name="agree"
        component={SingleCheckboxInput}
        label={
          <div className="max-w-sm">
            By ticking this box you confirm that you agree to our{" "}
            <a
              className="font-semibold text-easter"
              href="/terms"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Use
            </a>
            . You can edit payment duration at any time and cancel membership 30
            days before your next billing cycle.
          </div>
        }
      />
    </div>
  );
};

SubscriptionPlan.propTypes = {
  selectedPlan: PropTypes.number,
  setPlan: PropTypes.func.isRequired,
  navigateBack: PropTypes.func,
  tierInfo: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingPromoCode: PropTypes.bool.isRequired,
  liteOnly: PropTypes.bool.isRequired,
  referralCode: PropTypes.string,
};

SubscriptionPlan.defaultProps = {
  selectedPlan: null,
  navigateBack: null,
  referralCode: null,
};

export default SubscriptionPlan;
